import React, { useContext, useState, useEffect } from 'react';
import { Card, Col, Container, Row, Image, ListGroup } from 'react-bootstrap';
import MembershipTable from './membershiptable.component';
import AuthContext from '../../../../context/AuthProvider';
import { Gear, GearFill, GraphUpArrow, House, People, Person, PersonAdd, PersonBadge, PersonCircle } from 'react-bootstrap-icons';
import Analytics from './analytics.component';
import { useNavigate } from 'react-router-dom';
import { getURLParams } from '../../../../tools/main';
import { SideMenu } from './sidemenu';




export default function AdminView() {
    const {auth, setAuth} = useContext(AuthContext)
    const [isMounted, didMount] = useState(false)
    const [loading, isLoading] = useState(true)
    const [currentView, setView] = useState('manage-members')
    useEffect(()=> {
        didMount(true)

    }, [])
    useEffect(()=> {
        if (isMounted) isLoading(false)
    }, [auth, isMounted])

    useEffect(()=> {
        console.log(currentView)
    },[currentView])

    if (!loading) return (
        <Container className='mt-5 mb-90' style={{ 
                minHeight: "calc(100vh - 200px)",
                paddingTop: "80px",
                paddingBottom: "80px"}}>
            <Row className='mt-5 mb-90'>
                < MembershipTable />
            </Row>
        </Container>
        )
}

